import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What exactly is fractional franchise funding?",
    a: "It lets you subscribe to fractions of a pre-vetted franchise outlet (from ₹5,000) instead of underwriting the whole unit alone. Structured like peer-to-peer private lending, your fraction is issued as a CCD / NCD debt instrument collateralised against a real, operating franchise — and you earn passively without running the store.",
  },
  {
    q: "What is the 60:40 capital rule?",
    a: "Every outlet is funded 60% by the operator / franchise owner from their own equity, and 40% by investors. That investor 40% is raised from a pool of at most 200 verified individuals chosen by frantiger. Because the operator carries the majority stake, their incentives stay tightly aligned with yours.",
  },
  {
    q: "Who manages the outlet and its staff?",
    a: "Outlets are run either by the parent brand itself (FOCO model: franchise-owned, company-operated) or by vetted professional master-franchise operators onboarded through frantiger's verification process.",
  },
  {
    q: "How many investors can join one opportunity?",
    a: "A maximum of 200 verified investors can subscribe to any single pool. Every participating franchise unit is assigned a unique 6-letter identifier called a scrip (e.g., MCDHSR) that distinguishes it from all other units.",
  },
  {
    q: "Can I exit my investment before maturity?",
    a: "Yes — that's what makes fraction by frantiger unique. We provide secondary liquidity through Offer to Sell (list your fraction for other pool members to buy) and Offer to Buy (subscribe to fractions existing investors are selling). A flat ₹100 platform fee applies on each trade.",
  },
  {
    q: "What does frantiger charge for this?",
    a: "frantiger charges a 5% Annual Management Charge (AMC) covering underwriting, structuring, contracts and reporting. On the secondary board, a flat ₹100 platform fee applies per Offer to Buy / Offer to Sell transaction. There is no percentage brokerage.",
  },
  {
    q: "Is this regulated by SEBI? Is frantiger an investment advisor?",
    a: "No. frantiger is not a SEBI-registered investment advisor, research analyst, broker or intermediary. We are a franchise consulting platform collecting expressions of interest for alternative business participation. Please do your own due diligence before any decision.",
  },
  {
    q: "Can my franchise brand raise funds through fraction?",
    a: "Yes! Brands looking to expand across Indian Tier 1 and Tier 2 cities without high-interest debt can submit their details in the form above — choose 'Franchise Brand Owner' as your profile and our team will reach out.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-accordion-section" className="bg-[#eef2f7] py-24">
      <div className="mx-auto max-w-3xl px-4">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600">Investor FAQ</p>
          <h2 className="font-heading mt-4 text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Simple answers, in plain language
          </h2>
        </div>
        <Accordion type="single" collapsible className="mt-12 space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="neu-card rounded-3xl border-none px-6"
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger className="py-5 text-left font-heading text-base font-bold text-slate-900 hover:no-underline sm:text-lg" data-testid={`faq-trigger-${i + 1}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600 sm:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
